import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";

export const StyledButton = styled(Button)`
  background-color: transparent;
  padding: 0 0.7em 0 0.7em;
  display: inline-block;
  box-shadow: none;
  color: ${colours.elexonBlack};

  &:active {
    box-shadow: none;
  }

  &:hover {
    background-color: transparent;
    text-decoration: none;
  }

  &:focus {
    box-shadow: none;
  }
`;
